import { RadioButtonIcon } from '@phosphor-icons/react'
import styles from './TypeBox.module.scss'
import { ScoopText, ScoopRow, ScoopColumn } from '../../../../ui'

export const TypeBox = ({ title, description, active, setActive, index, enabled }) => {
    return (
        <ScoopRow
            onClick={() => {
                if (enabled) {
                    setActive(title)
                }
            }}
            className={`${styles.datasetTypeBox} ${active === title && styles.selected}`}
        >
            <RadioButtonIcon
                size={20}
                weight={active === title ? 'fill' : 'regular'}
                className={styles.radioIcon}
            />
            <ScoopColumn>
                <ScoopText className={styles.typeBoxTitle}>{title}</ScoopText>
                <ScoopText className={styles.typeBoxDescription}>{description}</ScoopText>
            </ScoopColumn>
        </ScoopRow>
    )
}
